import { useEffect, useState, useCallback, useMemo } from "react";
import { Add, Remove } from "@material-ui/icons";
import "./pos.css";
import { useDispatch, useSelector } from "react-redux";
import { getProducts } from "../../redux/apiCalls";
import { userRequest } from "../../requestMethods";
import { publicRequest } from "../../requestMethods";
import styled from "styled-components";
import { addProduct, clearCart, addQuantityIcon, removeProduct } from "../../redux/cartRedux";
import Select from "react-select";
import createCustomerInvoice from "../../components/pdf/createCustomerInvoice";
import { applySst } from "../../helpers/sst";
import SstIncludedField, { CartSstLine } from "./SstIncludedField";
import createDeposit from "../../components/pdf/createDeposit";
import { useLocation } from "react-router";

const ModalContainer = styled.div`
    height: 100%;
    width: 100%;
    opacity: 0.75;
    background: black;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    position: fixed;
    z-index: 10;
`;

const OverlayContainer = styled.div`
    overflow: hidden;
`;

const Overlay = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    color: white;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    top: 0;
    background-color: rgba(white, 0.5);
    visibility: visible;
`;

const ModalDetails = styled.div`
    background-color: rgba(white, 0.5);
    color: black;
    height: 100%;
    width: 50%;
    display: flex;
    z-index: 102;
`;

const EmptyModalDetails = styled.div`
    background-color: rgba(white, 0.5);
    color: black;
    height: 100%;
    width: 50%;
    display: flex;
    z-index: 102;
`;

const ModalItemContainer = styled.div`
    background-color: white;
    color: black;
    height: 100%;
    width: 100%;
    display: grid;
`;

const ColorPickerContainer = styled.div`
    overflow-y: auto;
    overflow-x: hidden;
    height: 100vh;
    display: grid;
    grid-template-columns: auto auto;
    z-index: 101;
            background: rgb(240, 240, 255);
`;


export default function EditOrder() {
    const dispatch = useDispatch();
    const location = useLocation();
    const products = useSelector((state) => state.product.products);
    const [colorpicker, setColorPicker] = useState(false);
    const [cashierMode, setCashierMode] = useState("sales");
    const [usersData, setUsersData] = useState([]);
    const [vehiclesData, setVehiclesData] = useState([]);
    const [cashiersData, setCashiersData] = useState([]);
    const [salespersonsData, setSalespersonsData] = useState([]);
    const [secondSalespersonsData, setSecondSalespersonsData] = useState([]);
    const [cardInterest, setCardInterest] = useState(0);
    const [name, setName] = useState("");
    const [inputs, setInputs] = useState({
        isProduct: true,
        paymentType: "cash",
    });
    const [itemDetails, setItemDetails] = useState({    
        name: undefined,
        price: undefined,
        type: undefined,
    });
   
    const [product, setProduct] = useState({});
    const [color, setColor] = useState({});
    const [filterList, setFilterList] = useState({
        type: "watch",
    });
    // eslint-disable-next-line
    const [productfilterCategory, setProductFilterCategory] = useState({
        status: "active",
        model: undefined,
        brand: undefined,
    });

    // eslint-disable-next-line
    const [quantity, setQuantity] = useState(1);

    const cart = useSelector((state) =>
        state.cart ? state.cart.products : []
    );

    const principle = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.principle : null
    );

    const currentUser = useSelector((state) => state.user.currentUser);

    const outright = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "outright"
            : null
    );

    const NumberFormatter = new Intl.NumberFormat("en-GB", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    const total = useSelector((state) =>
        state.cart ? (state.cart.total ? state.cart.total : 0) : 0
    );

    const cartTotalDue = () => {
        const afterDiscount = total - (Number(inputs.discount) || 0);
        return applySst(
            afterDiscount,
            inputs.commenceDate,
            inputs.sstIncluded === true
        );
    };

    // Custom sort order for products
    const productOrder = ['Jinko Panel', 'Module Bificial Dual Glass', 'Inverter', 'Warranty', 'Equipment', 'Others', 'Add On'];
    
    const sortedProducts = products ? [...products].sort((a, b) => {
        const indexA = productOrder.indexOf(a.title);
        const indexB = productOrder.indexOf(b.title);
        
        // If product is not in the order list, put it at the end
        const orderA = indexA === -1 ? productOrder.length : indexA;
        const orderB = indexB === -1 ? productOrder.length : indexB;
        
        return orderA - orderB;
    }) : [];


    let deconstructedProductList = [];
    cart.forEach((product) => {
        for (let i = 0; i < product.quantity; i++) {
            deconstructedProductList.push(product);
        }
    });



    const getUsers = async () => {
        const res = await publicRequest.get("/users/all", {
            params: {},
        });
        setUsersData(res.data);
    };

    const getVehicles = async () => {
        const res = await publicRequest.get("/users/all", {
            params: {},
        });
        setVehiclesData(res.data);
    };

    const getCashiers = useCallback(async () => {
        const res = await publicRequest.get("/users/allcashiers");
        setCashiersData(res.data);
    }, []);

    const getSalespersons = useCallback(async () => {
        const res = await publicRequest.get("/users/allsalesperson");
        setSalespersonsData(res.data);
    }, []);

    const getSecondSalespersons = useCallback(async () => {
        const res = await publicRequest.get("/users/allsalesperson");
        setSecondSalespersonsData(res.data);
    }, []);

    const handleChange = (e) => {
        setInputs((prev) => {
            return { ...prev, [e.target.name]: e.target.value };
        });
    };

    const handleSetItemDetails = (e) => {
        setItemDetails((prev) => {
            return { ...prev, [e.target.name]: e.target.value };
        });
    };

    const handleInputCashier = (e) => {
        const value = e.target ? e.target.value : e.value;
        setInputs((prev) => {
            return { ...prev, cashier: value };
        });
    };

    const handleInputSalesperson = (e) => {
        const value = e.target ? e.target.value : e.value;
        setInputs((prev) => {
            return { ...prev, salesperson: value };
        });
    };

    const handleInputSecondSalesperson = (e) => {
        const value = e.target ? e.target.value : e.value;
        setInputs((prev) => {
            return { ...prev, secondSalesperson: value };
        });
    };

    const handleInputVehicle = (e) => {
        const value = e.target ? e.target.value : e.value;
        setInputs((prev) => {
            return { ...prev, vehicle: value };
        });
    };

    const handleInputReferral = (e) => {
        const value = e.target ? e.target.value : e.value;
        setInputs((prev) => {
            return { ...prev, referral: value };
        });
    };

    const handleNameChange = (e) => {
        setName(e.target.value);
    };


    const handleQuantity = (
        product,
        quantity,
        amount,
        myAmount,
        activeColor
    ) => {
        dispatch(
            addQuantityIcon({
                ...product,
                quantity,
                amount,
                myAmount,
                activeColor,
            })
        );
    };

    const handleRemoveItem = (productToRemove, index) => {
        dispatch(
            removeProduct({
                index: index
            })
        );
    };

    const handlePosCreateOrder = async () => {
        let totalItems = 0;
        cart.forEach((item) => {
            if (item.type === "watch") {
                totalItems = totalItems + 1 * item.quantity;
            }
        });
        if (cart.length === 0) {
            alert("No product added!!");
            return;
        }

        if (total - inputs.discount < 0) {
            alert("Total cannot be a negative number");
            return;
        }

        const predata = location.state.order

        if (currentUser) {
            try {
                const res = await userRequest.put(`/orders/update/${predata._id}`, {
                    products: cart.map((item) => ({
                        productId: item._id,
                        quantity: item.amount,
                        code: item.title,
                        img: item.img,
                        price: item.price,
                        amount: item.amount,
                        type: item.type,
                        itemCode: item.itemCode,
                        system: item.system,
                    })),
                    amount: total,
                    discount: inputs.discount,
                    deposit: inputs.deposit,
                    userId: inputs.vehicle,
                    referral: inputs.referral,
                    kwp: inputs.kwp,
                    cashier: inputs.cashier,
                    salesperson: inputs.salesperson,
                    secondSalesperson: inputs.secondSalesperson,
                    team: inputs.team,
                    paymentType: inputs.paymentType,
                    cardInterest: cardInterest,
                    lineOne: inputs.lineOne,
                    lineTwo: inputs.lineTwo,
                    zip: inputs.zip,
                    city: inputs.city,
                    country: inputs.country,
                    remark: inputs.remark,
                    createdAt: inputs.createdAt,
                    sstIncluded: inputs.sstIncluded === true,
                });

                if (res.data) {
                    alert("Your order has been updated");
                    createCustomerInvoice(res.data);
                } else {
                    alert("Server issue, please contact support");
                }
            } catch (err) {
                alert(
                    "Failed to create order. Please check if the warranty is correct and belongs to this outlet. Please contact admin if you need support."
                );
            }
        } else {
            alert("Please login before checking out");
        }
    };

    const handleClear = async () => {
        dispatch(clearCart());
    };

    const handlePosDeposit = async () => {
        let totalItems = 0;
        cart.forEach((item) => {
            if (item.type === "watch") {
                totalItems = totalItems + 1 * item.quantity;
            }
        });
        if (cart.length === 0) {
            alert("No product added!!");
            return;
        }

        if (total - inputs.discount < 0) {
            alert("Total cannot be a negative number");
            return;
        }

        if (inputs.userId === undefined) {
            alert("Please select a customer first");
            return;
        }

        if (total - inputs.deposit < 0) {
            alert("Deposit cannot be more than sales total");
            return;
        }

        if (!inputs.deposit) {
            alert(
                `Deposit cannot be less than ${
                    process.env.REACT_APP_COUNTRY === "SINGAPORE" ? "$" : "RM"
                } 0.00`
            );
            return;
        }

        if (currentUser) {
            try {
                const createdBy = principle ? principle : currentUser._id;
                const res = await userRequest.post("/orders/deposit", {
                    userId: createdBy,
                    inputs,
                    products: cart.map((item) => ({
                        productId: item._id,
                        quantity: item.quantity,
                        code: `${item.model}-${item.color.name}`,
                        img: item.color.img,
                    })),
                    amount: total,
                    address: "POS Sales",
                    isProduct: true,
                    cashier: currentUser ? currentUser._id : undefined,
                });

                if (res.data) {
                    alert("Your deposit has been completed");
                    createDeposit(res.data);
                    dispatch(clearCart());
                } else {
                    alert("Server issue, please contact support");
                }
            } catch (err) {
                alert("Failed to create deposit, please check with admin");
            }
        } else {
            alert("Please login before checking out");
        }
    };

    const handleAddProduct = (product, color, quantity) => {
        try {
            dispatch(
                addProduct({
                    ...product,
                    activeColor: color ? color : itemDetails,
                    quantity,
                })
            );
        } catch {}
    };

    useEffect(() => {
        if (colorpicker === true) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [colorpicker]);

    useEffect(() => {
        if (usersData[0] === undefined) {
            getUsers();
        }
    }, [usersData]);

    useEffect(() => {
        if (vehiclesData[0] === undefined) {
            getVehicles();
        }
    }, [vehiclesData, dispatch]);

    useEffect(() => {
        if (cashiersData[0] === undefined) {
            getCashiers();
        }
    }, [getCashiers, cashiersData]);

    // Set cashier to current user if user type is outright
    useEffect(() => {
        if (outright && currentUser?._id) {
            setInputs((prev) => ({
                ...prev,
                cashier: currentUser._id,
            }));
        }
    }, [outright, currentUser?._id]);

    // Filter salespersons by principle if user type is outright
    const filteredSalespersonsData = useMemo(() => {
        if (outright && currentUser?._id) {
            return salespersonsData.filter(
                (user) => user.principle === currentUser._id || user.principle?._id === currentUser._id
            );
        }
        return salespersonsData;
    }, [salespersonsData, outright, currentUser?._id]);

    // Filter second salespersons by principle if user type is outright
    const filteredSecondSalespersonsData = useMemo(() => {
        if (outright && currentUser?._id) {
            return secondSalespersonsData.filter(
                (user) => user.principle === currentUser._id || user.principle?._id === currentUser._id
            );
        }
        return secondSalespersonsData;
    }, [secondSalespersonsData, outright, currentUser?._id]);

    useEffect(() => {
        if (salespersonsData[0] === undefined) {
            getSalespersons();
        }
    }, [salespersonsData, dispatch, getSalespersons]);

    useEffect(() => {
        if (secondSalespersonsData[0] === undefined) {
            getSecondSalespersons();
        }
    }, [secondSalespersonsData, dispatch, getSecondSalespersons]);

    useEffect(() => {
        getProducts(dispatch, productfilterCategory);
    }, [dispatch, filterList, productfilterCategory]);

    // Prefill form data when editing existing order
    useEffect(() => {
        if (location.state && location.state.order && vehiclesData.length > 0 && cashiersData.length > 0) {
            const existingOrder = location.state.order;
            setInputs(prev => ({
                ...prev,
                createdAt: existingOrder.createdAt || '',
                vehicle: existingOrder.userId ? existingOrder.userId._id : '',
                referral: existingOrder.referral ? existingOrder.referral._id : '',
                kwp: existingOrder.kwp || '',
                cashier: (outright && currentUser?._id) ? currentUser._id : (existingOrder.cashier ? existingOrder.cashier._id : ''),
                salesperson: existingOrder.salesperson ? existingOrder.salesperson._id : '',
                secondSalesperson: existingOrder.secondSalesperson ? existingOrder.secondSalesperson._id : '',
                team: existingOrder.team || 'Team J',
                paymentType: existingOrder.paymentType || 'cash',
                lineOne: existingOrder.lineOne || '',
                lineTwo: existingOrder.lineTwo || '',
                zip: existingOrder.zip || '',
                city: existingOrder.city || '',
                country: existingOrder.country || '',
                remark: existingOrder.remark || '',
                affiliateCode: existingOrder.affiliateCode || '',
                discount: existingOrder.discount || 0,
                deposit: existingOrder.deposit || 0,
                sstIncluded: existingOrder.sstIncluded === true,
                commenceDate: existingOrder.commenceDate || undefined,
            }));
            setCardInterest(existingOrder.cardInterest || 0);
        }
    }, [location.state, vehiclesData, cashiersData, outright, currentUser?._id]);

    // Cleanup effect to clear cart when component unmounts or route changes
    useEffect(() => {
        return () => {
            // Clear cart when component unmounts (page exit or route change)
            dispatch(clearCart());
        };
    }, [dispatch]);

    return (
        <div className="pos">
            <div className="userContainer">
                <div className="checkoutButtons">
                    <div
                        className="salesButton lightyellow"
                        onClick={() => setCashierMode("sales")}
                    >
                        Sales
                    </div>
                </div>
                
                <div className="calculator">
                    <div className="cartContainer">
                        <div className="cartTitle">Service</div>

                        <div className="cartTitle">Quantity</div>
                        <div className="cartTitle">Total Price</div>
                    </div>
                    {cart ? (
                        cart.map((product, i) => (
                            <div className="cartContainer" key={i}>
                                <div className="cartItem capitalize">
                                    {product.title}
                                </div>
                                <div className="quantityItem">
                                    <Add
                                        style={{ fontSize: "0.8rem" }}
                                        onClick={() =>
                                            handleQuantity(
                                                product,
                                                1,
                                                product.price,
                                                product.price,
                                                product.color
                                            )
                                        }
                                    />
                                    {product.amount}
                                    <Remove
                                        style={{ fontSize: "0.8rem", cursor: "pointer" }}
                                        onClick={() => handleRemoveItem(product, i)}
                                    />
                                </div>
                                <div className="cartItem">
                                    {process.env.REACT_APP_COUNTRY ===
                                    "SINGAPORE"
                                        ? "$"
                                        : "RM"}
                                    {(product.price * product.amount).toFixed(2)}
                                </div>
                            </div>
                        ))
                    ) : (
                        <></>
                    )}
                </div>
                <div className="summary">
                    <div className="summarysubtotal">SubTotal </div>
                    <div className="summarysubtotal">
                        {process.env.REACT_APP_COUNTRY === "SINGAPORE"
                            ? "$"
                            : "RM"}
                        {total ? NumberFormatter.format(total) : "0"}
                    </div>
                </div>

                <div className="summary depositPadding">
                    <div className="addDiscountItem">
                        <div className="summarysubtotal">Discount</div>
                        <input
                            name="discount"
                            type="number"
                            value={inputs.discount || ''}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <CartSstLine
                    sstIncluded={inputs.sstIncluded}
                    afterDiscount={total - (Number(inputs.discount) || 0)}
                    commenceDate={inputs.commenceDate}
                />
                
                <div className="possummaryContainer">
                    <div className="addProductItem fullWidth">
                        <label>Date of Issue</label>
                        <input
                            type="date"
                            value={inputs.createdAt ? new Date(inputs.createdAt).toISOString().split('T')[0] : ''}
                            onChange={(e) =>
                                setInputs((prev) => ({
                                    ...prev,
                                    createdAt: new Date(e.target.value).toISOString(),
                                }))
                            }
                        />
                    </div>
                    <div className="addProductItem fullWidth">
                        <label>Deposit</label>
                        <input
                            name="deposit"
                            type="number"
                            placeholder="Enter deposit amount"
                            value={inputs.deposit || ''}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="addProductItem fullWidth">
                        <label>Customer</label>
                        <Select
                            options={vehiclesData.map((user, i) => {
                                return {
                                    label: `${user.phoneNumber}-${user.name}`,
                                    value: user._id,
                                };
                            })}
                            value={inputs.vehicle && vehiclesData.length > 0 && vehiclesData.find(user => user._id === inputs.vehicle) ? {
                                label: `${vehiclesData.find(user => user._id === inputs.vehicle).phoneNumber}-${vehiclesData.find(user => user._id === inputs.vehicle).name}`,
                                value: inputs.vehicle
                            } : null}
                            onChange={handleInputVehicle}
                            placeholder="Select Customer"
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    padding: '0',
                                    border: '1px solid #ccc',
                                    borderRadius: '6px',
                                    fontSize: '17px',
                                    fontFamily: 'FuturaPT-Book',
                                    background: 'white',
                                    boxShadow: 'none',
                                    minHeight: '44px',
                                    cursor: 'pointer',
                                    '&:hover': {
                                        borderColor: '#ccc',
                                    }
                                }),
                                valueContainer: (base) => ({
                                    ...base,
                                    padding: '12px',
                                }),
                                input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0',
                                }),
                                placeholder: (base) => ({
                                    ...base,
                                    fontFamily: 'FuturaPT-Book',
                                    fontSize: '17px',
                                }),
                                singleValue: (base) => ({
                                    ...base,
                                    fontFamily: 'FuturaPT-Book',
                                    fontSize: '17px',
                                }),
                                indicatorSeparator: () => ({
                                    display: 'none',
                                }),
                                dropdownIndicator: (base) => ({
                                    ...base,
                                    padding: '8px',
                                }),
                            }}
                        />
                    </div>
                   
                    <div className="addProductItem fullWidth">
                        <label>Referral</label>
                        <Select
                            options={vehiclesData.map((user, i) => {
                                return {
                                    label: `${user.phoneNumber}-${user.name}`,
                                    value: user._id,
                                };
                            })}
                            value={inputs.referral && vehiclesData.length > 0 && vehiclesData.find(user => user._id === inputs.referral) ? {
                                label: `${vehiclesData.find(user => user._id === inputs.referral).phoneNumber}-${vehiclesData.find(user => user._id === inputs.referral).name}`,
                                value: inputs.referral
                            } : null}
                            onChange={handleInputReferral}
                            placeholder="Select Referral"
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    padding: '0',
                                    border: '1px solid #ccc',
                                    borderRadius: '6px',
                                    fontSize: '17px',
                                    fontFamily: 'FuturaPT-Book',
                                    background: 'white',
                                    boxShadow: 'none',
                                    minHeight: '44px',
                                    cursor: 'pointer',
                                    '&:hover': {
                                        borderColor: '#ccc',
                                    }
                                }),
                                valueContainer: (base) => ({
                                    ...base,
                                    padding: '12px',
                                }),
                                input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0',
                                }),
                                placeholder: (base) => ({
                                    ...base,
                                    fontFamily: 'FuturaPT-Book',
                                    fontSize: '17px',
                                }),
                                singleValue: (base) => ({
                                    ...base,
                                    fontFamily: 'FuturaPT-Book',
                                    fontSize: '17px',
                                }),
                                indicatorSeparator: () => ({
                                    display: 'none',
                                }),
                                dropdownIndicator: (base) => ({
                                    ...base,
                                    padding: '8px',
                                }),
                            }}
                        />
                    </div>


                    {!outright && (
                        <div className="addProductItem fullWidth">
                            <label>Cashier</label>
                            <Select
                                options={cashiersData.map((user, i) => {
                                    return {
                                        label: `${user.name}`,
                                        value: user._id,
                                    };
                                })}
                                value={inputs.cashier && cashiersData.length > 0 && cashiersData.find(user => user._id === inputs.cashier) ? {
                                    label: `${cashiersData.find(user => user._id === inputs.cashier).name}`,
                                    value: inputs.cashier
                                } : null}
                                onChange={handleInputCashier}
                                placeholder="Select Cashier"
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    padding: '0',
                                    border: '1px solid #ccc',
                                    borderRadius: '6px',
                                    fontSize: '17px',
                                    fontFamily: 'FuturaPT-Book',
                                    background: 'white',
                                    boxShadow: 'none',
                                    minHeight: '44px',
                                    cursor: 'pointer',
                                    '&:hover': {
                                        borderColor: '#ccc',
                                    }
                                }),
                                valueContainer: (base) => ({
                                    ...base,
                                    padding: '12px',
                                }),
                                input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0',
                                }),
                                placeholder: (base) => ({
                                    ...base,
                                    fontFamily: 'FuturaPT-Book',
                                    fontSize: '17px',
                                }),
                                singleValue: (base) => ({
                                    ...base,
                                    fontFamily: 'FuturaPT-Book',
                                    fontSize: '17px',
                                }),
                                indicatorSeparator: () => ({
                                    display: 'none',
                                }),
                                dropdownIndicator: (base) => ({
                                    ...base,
                                    padding: '8px',
                                }),
                            }}
                        />
                    </div>
                    )}
                    <div className="addProductItem fullWidth">
                        <label>Salesperson</label>
                        <Select
                            options={filteredSalespersonsData.map((user, i) => {
                                return {
                                    label: `${user.name}`,
                                    value: user._id,
                                };
                            })}
                            value={inputs.salesperson && filteredSalespersonsData.length > 0 && filteredSalespersonsData.find(user => user._id === inputs.salesperson) ? {
                                label: `${filteredSalespersonsData.find(user => user._id === inputs.salesperson).name}`,
                                value: inputs.salesperson
                            } : null}
                            onChange={handleInputSalesperson}
                            placeholder="Select Salesperson"
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    padding: '0',
                                    border: '1px solid #ccc',
                                    borderRadius: '6px',
                                    fontSize: '17px',
                                    fontFamily: 'FuturaPT-Book',
                                    background: 'white',
                                    boxShadow: 'none',
                                    minHeight: '44px',
                                    cursor: 'pointer',
                                    '&:hover': {
                                        borderColor: '#ccc',
                                    }
                                }),
                                valueContainer: (base) => ({
                                    ...base,
                                    padding: '12px',
                                }),
                                input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0',
                                }),
                                placeholder: (base) => ({
                                    ...base,
                                    fontFamily: 'FuturaPT-Book',
                                    fontSize: '17px',
                                }),
                                singleValue: (base) => ({
                                    ...base,
                                    fontFamily: 'FuturaPT-Book',
                                    fontSize: '17px',
                                }),
                                indicatorSeparator: () => ({
                                    display: 'none',
                                }),
                                dropdownIndicator: (base) => ({
                                    ...base,
                                    padding: '8px',
                                }),
                            }}
                        />
                    </div>
                    <div className="addProductItem fullWidth">
                        <label>Second Salesperson</label>
                        <Select
                            options={filteredSecondSalespersonsData.map((user, i) => {
                                return {
                                    label: `${user.name}`,
                                    value: user._id,
                                };
                            })}
                            value={inputs.secondSalesperson && filteredSecondSalespersonsData.length > 0 && filteredSecondSalespersonsData.find(user => user._id === inputs.secondSalesperson) ? {
                                label: `${filteredSecondSalespersonsData.find(user => user._id === inputs.secondSalesperson).name}`,
                                value: inputs.secondSalesperson
                            } : null}
                            onChange={handleInputSecondSalesperson}
                            placeholder="Select Second Salesperson"
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    padding: '0',
                                    border: '1px solid #ccc',
                                    borderRadius: '6px',
                                    fontSize: '17px',
                                    fontFamily: 'FuturaPT-Book',
                                    background: 'white',
                                    boxShadow: 'none',
                                    minHeight: '44px',
                                    cursor: 'pointer',
                                    '&:hover': {
                                        borderColor: '#ccc',
                                    }
                                }),
                                valueContainer: (base) => ({
                                    ...base,
                                    padding: '12px',
                                }),
                                input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0',
                                }),
                                placeholder: (base) => ({
                                    ...base,
                                    fontFamily: 'FuturaPT-Book',
                                    fontSize: '17px',
                                }),
                                singleValue: (base) => ({
                                    ...base,
                                    fontFamily: 'FuturaPT-Book',
                                    fontSize: '17px',
                                }),
                                indicatorSeparator: () => ({
                                    display: 'none',
                                }),
                                dropdownIndicator: (base) => ({
                                    ...base,
                                    padding: '8px',
                                }),
                            }}
                        />
                    </div>
                    <div className="addProductItem fullWidth">
                        <label>Team</label>
                        <div style={{ display: "flex", gap: "12px", marginTop: "8px" }}>
                            <button
                                type="button"
                                onClick={() =>
                                    setInputs((prev) => ({
                                        ...prev,
                                        team: "Team J",
                                    }))
                                }
                                style={{
                                    flex: 1,
                                    padding: "12px",
                                    border: inputs.team === "Team J" ? "2px solid #2A3F96" : "1px solid #ccc",
                                    borderRadius: "6px",
                                    fontSize: "17px",
                                    fontFamily: "FuturaPT-Book",
                                    background: inputs.team === "Team J" ? "#2A3F96" : "white",
                                    color: inputs.team === "Team J" ? "white" : "#232323",
                                    cursor: "pointer",
                                    transition: "all 0.2s",
                                }}
                            >
                                Team J
                            </button>
                            <button
                                type="button"
                                onClick={() =>
                                    setInputs((prev) => ({
                                        ...prev,
                                        team: "Team M",
                                    }))
                                }
                                style={{
                                    flex: 1,
                                    padding: "12px",
                                    border: inputs.team === "Team M" ? "2px solid #2A3F96" : "1px solid #ccc",
                                    borderRadius: "6px",
                                    fontSize: "17px",
                                    fontFamily: "FuturaPT-Book",
                                    background: inputs.team === "Team M" ? "#2A3F96" : "white",
                                    color: inputs.team === "Team M" ? "white" : "#232323",
                                    cursor: "pointer",
                                    transition: "all 0.2s",
                                }}
                            >
                                Team M
                            </button>
                        </div>
                    </div>
                    <SstIncludedField
                        sstIncluded={inputs.sstIncluded}
                        onChange={(value) =>
                            setInputs((prev) => ({
                                ...prev,
                                sstIncluded: value,
                            }))
                        }
                        afterDiscount={total - (Number(inputs.discount) || 0)}
                        commenceDate={inputs.commenceDate}
                    />
                    <div className="addProductItem fullWidth">
                        <label>Address Line 1</label>
                        <input
                            type="text"
                            placeholder="Address Line 1"
                            value={inputs.lineOne || ''}
                            onChange={(e) =>
                                setInputs((prev) => ({
                                    ...prev,
                                    lineOne: e.target.value,
                                }))
                            }
                        />
                    </div>
                    <div className="addProductItem fullWidth">
                        <label>Address Line 2</label>
                        <input
                            type="text"
                            placeholder="Address Line 2"
                            value={inputs.lineTwo || ''}
                            onChange={(e) =>
                                setInputs((prev) => ({
                                    ...prev,
                                    lineTwo: e.target.value,
                                }))
                            }
                        />
                    </div>
                    <div className="addProductItem fullWidth">
                        <label>Postal Code</label>
                        <input
                            type="text"
                            placeholder="Postal Code"
                            value={inputs.zip || ''}
                            onChange={(e) =>
                                setInputs((prev) => ({
                                    ...prev,
                                    zip: e.target.value,
                                }))
                            }
                        />
                    </div>
                    <div className="addProductItem fullWidth">
                        <label>City</label>
                        <input
                            type="text"
                            placeholder="City"
                            value={inputs.city || ''}
                            onChange={(e) =>
                                setInputs((prev) => ({
                                    ...prev,
                                    city: e.target.value,
                                }))
                            }
                        />
                    </div>
                    <div className="addProductItem fullWidth">
                        <label>State</label>
                        <input
                            type="text"
                            placeholder="State"
                            value={inputs.country || ''}
                            onChange={(e) =>
                                setInputs((prev) => ({
                                    ...prev,
                                    country: e.target.value,
                                }))
                            }
                        />
                    </div>
                    <div className="addProductItem fullWidth">
                        <label>Payment Type</label>
                        <Select
                            value={
                                [
                                    { value: 'cash', label: 'Cash' },
                                    { value: 'cheque', label: 'Cheque' },
                                    { value: 'card', label: 'Card' },
                                    { value: 'onlineTransfer', label: 'Online Transfer' }
                                ].find(opt => opt.value === inputs.paymentType)
                            }
                            onChange={option => {
                                setInputs(prev => ({
                                    ...prev,
                                    paymentType: option.value,
                                }))
                            }}
                            options={[
                                { value: 'cash', label: 'Cash' },
                                { value: 'cheque', label: 'Cheque' },
                                { value: 'card', label: 'Card' },
                                { value: 'onlineTransfer', label: 'Online Transfer' }
                            ]}
                            placeholder="Select Payment Type"
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    padding: '0',
                                    border: '1px solid #ccc',
                                    borderRadius: '6px',
                                    fontSize: '17px',
                                    fontFamily: 'FuturaPT-Book',
                                    background: 'white',
                                    boxShadow: 'none',
                                    minHeight: '44px',
                                    cursor: 'pointer',
                                    '&:hover': {
                                        borderColor: '#ccc',
                                    }
                                }),
                                valueContainer: (base) => ({
                                    ...base,
                                    padding: '12px',
                                }),
                                input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0',
                                }),
                                placeholder: (base) => ({
                                    ...base,
                                    fontFamily: 'FuturaPT-Book',
                                    fontSize: '17px',
                                }),
                                singleValue: (base) => ({
                                    ...base,
                                    fontFamily: 'FuturaPT-Book',
                                    fontSize: '17px',
                                }),
                                indicatorSeparator: () => ({
                                    display: 'none',
                                }),
                                dropdownIndicator: (base) => ({
                                    ...base,
                                    padding: '8px',
                                }),
                            }}
                        />
                    </div>

                    <div className="addProductItem fullWidth">
                        <label>Card Interest</label>
                        <input
                            type="number"
                            placeholder="Enter card interest amount"
                            value={cardInterest}
                            onChange={(e) => setCardInterest(e.target.value)}
                        />
                    </div>
                    <div className="addProductItem fullWidth">
                        <label>Remark (Optional)</label>
                        <textarea
                            placeholder="Remark"
                            rows={5}
                            style={{padding: "10px", resize: "vertical"}}
                            value={inputs.remark || ''}
                            onChange={(e) =>
                                setInputs((prev) => ({
                                    ...prev,
                                    remark: e.target.value,
                                }))
                            }
                        />
                    </div>
                </div>

                {cashierMode === "sales" && (
                    <>
                        <div className="summary totalButton">
                            <div className="summarysubtotal">Total </div>
                            <div className="summarysubtotal">
                                {process.env.REACT_APP_COUNTRY === "SINGAPORE"
                                    ? "$"
                                    : "RM"}
                                {NumberFormatter.format(cartTotalDue())}
                            </div>
                        </div>

                        <div className="checkoutButtons">
                            <div
                                className="salesButton sales"
                                onClick={handlePosCreateOrder}
                            >
                                Sales{" "}
                            </div>
                        </div>


                        <div className="checkoutButtons">
                            <div
                                className="salesButton reset"
                                onClick={handleClear}
                            >
                                Full Reset
                            </div>
                        </div>
                        {/* <div
                            className="summary totalButton pointer lightblue"
                            onClick={() => handleWhatsapp()}
                        >
                            Whatsapp
                        </div> */}
                    </>
                )}

                {cashierMode === "deposit" && (
                    <>
                        <div className="summary depositPadding">
                            <div className="addDiscountItem">
                                <div className="summarysubtotal">Deposit</div>
                                <input
                                    name="deposit"
                                    type="number"
                                    onChange={handleChange}
                                    defaultValue={""}
                                />
                            </div>
                        </div>
                        <div className="summary totalButton">
                            <div className="summarysubtotal">Remaining </div>
                            <div className="summarysubtotal">
                                {process.env.REACT_APP_COUNTRY === "SINGAPORE"
                                    ? "$"
                                    : "RM"}
                                {NumberFormatter.format(
                                    cartTotalDue() -
                                        (Number(inputs.deposit) || 0)
                                )}
                            </div>
                        </div>
                        <div className="">
                            <div
                                className="salesButton deposit"
                                onClick={handlePosDeposit}
                            >
                                Deposit{" "}
                            </div>
                        </div>
                    </>
                )}
            </div>

            {colorpicker && (
                <OverlayContainer>
                    <ModalContainer></ModalContainer>
                    <Overlay>
                        <EmptyModalDetails
                            onClick={() => setColorPicker(false)}
                        ></EmptyModalDetails>
                        <ModalDetails>
                            <ModalItemContainer>
                                <ColorPickerContainer>
                                    <div className="itemDetailsContainer">
                                        <div className="summary" style={{ flexDirection: 'column', width: '100%', maxWidth: '100%', gap: '12px', alignItems: 'stretch', alignSelf: 'stretch', boxSizing: 'border-box', paddingLeft: 0, paddingRight: 0 }}>
                                            <div className="addProductItem fullWidth" style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
                                                <label>Name</label>
                                                <input
                                                    name="name"
                                                    type="text"
                                                    placeholder="Enter name"
                                                    value={itemDetails.name || ""}
                                                    onChange={handleSetItemDetails}
                                                    style={{
                                                        padding: '12px',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '6px',
                                                        fontSize: '17px',
                                                        fontFamily: 'FuturaPT-Book',
                                                        background: 'white',
                                                        width: '100%',
                                                        boxSizing: 'border-box',
                                                    }}
                                                />
                                            </div>
                                            <div className="addProductItem fullWidth" style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
                                                <label>Price</label>
                                                <input
                                                    name="price"
                                                    type="number"
                                                    placeholder="Enter price"
                                                    value={itemDetails.price ?? ""}
                                                    onChange={handleSetItemDetails}
                                                    style={{
                                                        padding: '12px',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '6px',
                                                        fontSize: '17px',
                                                        fontFamily: 'FuturaPT-Book',
                                                        background: 'white',
                                                        width: '100%',
                                                        boxSizing: 'border-box',
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="summary">
                                            <div className="addProductItem fullWidth">
                                                {itemDetails.name ===
                                                    "Inverter" && (
                                                    <select
                                                        name="type"
                                                        onChange={
                                                            handleSetItemDetails
                                                        }
                                                        style={{
                                                            padding: '12px',
                                                            border: '1px solid #ccc',
                                                            borderRadius: '6px',
                                                            fontSize: '17px',
                                                            fontFamily: 'FuturaPT-Book',
                                                            background: 'white',
                                                            width: '100%',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        <option value="">
                                                            Select Type
                                                        </option>
                                                        <option value="Solis">
                                                            Solis
                                                        </option>
                                                        <option value="Sunglow">
                                                            Sunglow
                                                        </option>
                                                        <option value="Goodwe">
                                                            Goodwe
                                                        </option>
                                                        <option value="Huawei">
                                                            Huawei
                                                        </option>
                                                        <option value="Solax">
                                                            Solax
                                                        </option>
                                                        <option value="Hoymiles">
                                                           Hoymiles
                                                        </option>
                                                    </select>
                                                )}
                                                {itemDetails.name ===
                                                    "Jinko Panel" && (
                                                    <select
                                                        name="type"
                                                        onChange={
                                                            handleSetItemDetails
                                                        }
                                                        style={{
                                                            padding: '12px',
                                                            border: '1px solid #ccc',
                                                            borderRadius: '6px',
                                                            fontSize: '17px',
                                                            fontFamily: 'FuturaPT-Book',
                                                            background: 'white',
                                                            width: '100%',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        <option value="">
                                                            Select Type
                                                        </option>
                                                        <option value="Jinko Tiger Neo N-type">
                                                            Jinko Tiger Neo
                                                            N-type
                                                        </option>
                                                    </select>
                                                )}
                                                {itemDetails.name ===
                                                    "Module Bificial Dual Glass" && (
                                                    <select
                                                        name="type"
                                                        onChange={
                                                            handleSetItemDetails
                                                        }
                                                        style={{
                                                            padding: '12px',
                                                            border: '1px solid #ccc',
                                                            borderRadius: '6px',
                                                            fontSize: '17px',
                                                            fontFamily: 'FuturaPT-Book',
                                                            background: 'white',
                                                            width: '100%',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        <option value="">
                                                            Select Type
                                                        </option>
                                                        <option value="Module Bificial Dual Glass">
                                                            Module Bificial Dual
                                                            Glass
                                                        </option>
                                                    </select>
                                                )}
                                                {itemDetails.name ===
                                                    "Warranty" && (
                                                    <select
                                                        name="type"
                                                        onChange={
                                                            handleSetItemDetails
                                                        }
                                                        style={{
                                                            padding: '12px',
                                                            border: '1px solid #ccc',
                                                            borderRadius: '6px',
                                                            fontSize: '17px',
                                                            fontFamily: 'FuturaPT-Book',
                                                            background: 'white',
                                                            width: '100%',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        <option value="">
                                                            Select Type
                                                        </option>
                                                        <option value="2 years Warranty (Workmanship)">
                                                            2 years Warranty
                                                            (Workmanship)
                                                        </option>
                                                        <option value="3 years Warranty (Workmanship)">
                                                            3 years Warranty
                                                            (Workmanship)
                                                        </option>
                                                        <option value="15 years Warranty (Workmanship)">
                                                            15 years Warranty
                                                            (Workmanship)
                                                        </option>
                                                    </select>
                                                )}
                                                {itemDetails.name ===
                                                    "Add On" && (
                                                    <select
                                                        name="type"
                                                        onChange={
                                                            handleSetItemDetails
                                                        }
                                                        style={{
                                                            padding: '12px',
                                                            border: '1px solid #ccc',
                                                            borderRadius: '6px',
                                                            fontSize: '17px',
                                                            fontFamily: 'FuturaPT-Book',
                                                            background: 'white',
                                                            width: '100%',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        <option value="">
                                                            Select Type
                                                        </option>
                                                        <option value="Maintenance">
                                                            Maintenance
                                                        </option>
                                                        <option value="Insurance">
                                                            Insurance
                                                        </option>
                                                        <option value="Upgrade inverter">
                                                            Upgrade inverter
                                                        </option>
                                                        <option value="Balast system">
                                                            Balast system
                                                        </option>
                                                        <option value="Outstation Fee">
                                                            Outstation Fee
                                                        </option>
                                                        <option value="580W Panel">
                                                            580W Panel
                                                        </option>
                                                        <option value="590W Panel">
                                                            590W Panel
                                                        </option>
                                                        <option value="620W Panel">
                                                            620W Panel
                                                        </option>
                                                    </select>
                                                )}
                                                {itemDetails.name ===
                                                    "Others" && (
                                                    <input
                                                        type="text"
                                                        name="type"
                                                        placeholder="Enter type"
                                                        onChange={
                                                            handleSetItemDetails
                                                        }
                                                    />
                                                )}
                                                {itemDetails.name ===
                                                    "Equipment" && (
                                                    <select
                                                        name="type"
                                                        onChange={(e) => {
                                                            const selectedOption = e.target.options[e.target.selectedIndex];
                                                            setItemDetails((prev) => ({
                                                                ...prev,
                                                                type: e.target.value,
                                                                fullTitle: selectedOption.text
                                                            }));
                                                        }}
                                                        style={{
                                                            padding: '12px',
                                                            border: '1px solid #ccc',
                                                            borderRadius: '6px',
                                                            fontSize: '17px',
                                                            fontFamily: 'FuturaPT-Book',
                                                            background: 'white',
                                                            width: '100%',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        <option value="">
                                                            Select Equipment
                                                        </option>
                                                        <option value="PPS2200">
                                                            Outdoor solar powerstation+2 solar panel package
                                                        </option>
                                                        <option value="M2200">
                                                            Outdoor solar powerstation
                                                        </option>
                                                        <option value="P2200">
                                                            Expandable powerstation
                                                        </option>
                                                        <option value="PPS2200Pro">
                                                            Outdoor solar powerstation(fast charge)+2 solar panel package
                                                        </option>
                                                        <option value="S2200Pro">
                                                            Outdoor solar powerstation(fast charge)
                                                        </option>
                                                        <option value="B2200-F">
                                                            Expandable powerstation
                                                        </option>
                                                        <option value="XS500-F">
                                                            Outdoor solar powerstation
                                                        </option>
                                                        <option value="MJ-BW300C">
                                                            CCTV smart solar flood light 300W
                                                        </option>
                                                        <option value="MJ-BW500C">
                                                            CCTV smart solar flood light 500W
                                                        </option>
                                                        <option value="SP-220W">
                                                            Solar panel 220W 太阳能板
                                                        </option>
                                                        <option value="MJ-SF01">
                                                            Solar Fan太阳能风扇
                                                        </option>
                                                        <option value="MJ-EW800">
                                                            Exlorer Warrior Garden Light 800W (Primary Version)
                                                        </option>
                                                        <option value="MJ-EW1200">
                                                            Exlorer Warrior Garden Light 1200W (Primary Version)
                                                        </option>
                                                        <option value="MJ-SFL100">
                                                            Solar flood light 100W (Primary Version)
                                                        </option>
                                                        <option value="MJ-SFL200">
                                                            Solar flood light 200W (Primary Version)
                                                        </option>
                                                        <option value="MJ-SFL300">
                                                            Solar flood light 300W (Primary Version)
                                                        </option>
                                                        <option value="MJ-SFL500">
                                                            Solar flood light 500W (Primary Version)
                                                        </option>
                                                        <option value="MJ-SSO100C">
                                                            CCTV Version 100W Excluded SIM Card & TF Card
                                                        </option>
                                                        <option value="MJ-SSO200C">
                                                            CCTV Version 200W Excluded SIM Card & TF Card
                                                        </option>
                                                        <option value="MJ-SSO100">
                                                            No CCTV Version 100W Excluded SIM Card & TF Card
                                                        </option>
                                                        <option value="MJ-SSO200">
                                                            No CCTV Version 200W Excluded SIM Card & TF Card
                                                        </option>
                                                        <option value="MJ-SSTH800">
                                                            Solar Street Light Primary Version 800W
                                                        </option>
                                                        <option value="MJ-SSTH1200">
                                                            Solar Street Light Primary Version 1200W
                                                        </option>
                                                        <option value="MJ-SSL902">
                                                            Solar Street Light 200W
                                                        </option>
                                                        <option value="MJ-SSL903">
                                                            Solar Street Light 300W
                                                        </option>
                                                    </select>
                                                )}
                                            </div>
                                        </div>

                                        {itemDetails.name === "Inverter" && (
                                            <div className="summary">
                                                <div className="addProductItem fullWidth">
                                                    <label>KW</label>
                                                    <input
                                                        name="KW"
                                                        type="number"
                                                        onChange={
                                                            handleSetItemDetails
                                                        }
                                                        defaultValue={""}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        {itemDetails.name === "Inverter" && (
                                            <div className="summary">
                                                <div className="addProductItem fullWidth">
                                                    <label>Battery</label>
                                                    <select
                                                        name="battery"
                                                        onChange={
                                                            handleSetItemDetails
                                                        }
                                                        style={{
                                                            padding: '12px',
                                                            border: '1px solid #ccc',
                                                            borderRadius: '6px',
                                                            fontSize: '17px',
                                                            fontFamily: 'FuturaPT-Book',
                                                            background: 'white',
                                                            width: '100%',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        <option value="">
                                                            Select Battery
                                                        </option>
                                                        <option value="SELCO BESS BATTERY">
                                                            SELCO BESS BATTERY
                                                        </option>
                                                        <option value="HYBRID READY">
                                                            HYBRID READY
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        )}

{itemDetails.name === "Jinko Panel" && (
                                            <div className="summary">
                                                <div className="addProductItem fullWidth">
                                                    <label>System</label>
                                                    <select
                                                        name="system"
                                                        onChange={handleSetItemDetails}
                                                        style={{
                                                            padding: '12px',
                                                            border: '1px solid #ccc',
                                                            borderRadius: '6px',
                                                            fontSize: '17px',
                                                            fontFamily: 'FuturaPT-Book',
                                                            background: 'white',
                                                            width: '100%',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        <option value="">Select System</option>
                                                        <option value="NEM">NEM</option>
                                                        <option value="ATAP">ATAP</option>
                                                        <option value="SELCO">SELCO</option>
                                                        <option value="SELCO + ATAP">SELCO + ATAP</option>
                                                    </select>
                                                </div>
                                            </div>
                                        )}

                                        {itemDetails.name === "Jinko Panel" && (
                                            <div className="summary">
                                                <div className="addProductItem fullWidth">
                                                    <label>Phase</label>
                                                    <select
                                                        name="phase"
                                                        onChange={handleSetItemDetails}
                                                        style={{
                                                            padding: '12px',
                                                            border: '1px solid #ccc',
                                                            borderRadius: '6px',
                                                            fontSize: '17px',
                                                            fontFamily: 'FuturaPT-Book',
                                                            background: 'white',
                                                            width: '100%',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        <option value="">Select Phase</option>
                                                        <option value="Single">Single</option>
                                                        <option value="Three">Three</option>
                                                    </select>
                                                </div>
                                            </div>
                                        )}

                                        {itemDetails.name === "Jinko Panel" && (
                                            <div className="summary">
                                                <div className="addProductItem fullWidth">
                                                    <label>Voltage</label>
                                                    <select
                                                        name="voltage"
                                                        onChange={handleSetItemDetails}
                                                        style={{
                                                            padding: '12px',
                                                            border: '1px solid #ccc',
                                                            borderRadius: '6px',
                                                            fontSize: '17px',
                                                            fontFamily: 'FuturaPT-Book',
                                                            background: 'white',
                                                            width: '100%',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        <option value="">Select Voltage</option>
                                                        <option value="580W">580W</option>
                                                        <option value="590W">590W</option>
                                                        <option value="620W">620W</option>
                                                    </select>
                                                </div>
                                            </div>
                                        )}

{itemDetails.name === "Jinko Panel" && (
                                            <div className="summary">
                                                <div className="addProductItem fullWidth">
                                                    <label>Quantity</label>
                                                    <input
                                                        name="quantity"
                                                        type="number"
                                                        onChange={handleSetItemDetails}
                                                        defaultValue={""}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        {(itemDetails.name === "Jinko Panel" ||
                                            itemDetails.name === "Add On" ||
                                            itemDetails.name === "Others" ||
                                            itemDetails.name === "Equipment") && (
                                            <div className="summary">
                                                <div className="addProductItem fullWidth">
                                                    <label>Price</label>
                                                    <input
                                                        name="price"
                                                        type="number"
                                                        onChange={
                                                            handleSetItemDetails
                                                        }
                                                        defaultValue={""}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        {itemDetails.name === "Jinko Panel" && (
                                            <div className="summary">
                                                <div className="addProductItem fullWidth">
                                                    <label>KWP</label>
                                                    <input
                                                        name="kwp"
                                                        type="number"
                                                        placeholder="KWP"
                                                        onChange={
                                                            handleSetItemDetails
                                                        }
                                                        defaultValue={""}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        <button
                                            className="productListEdit mt-2"
                                            onClick={() => {
                                                // Update main inputs with KWP value from popup
                                                if (itemDetails.kwp) {
                                                    setInputs((prev) => ({
                                                        ...prev,
                                                        kwp: itemDetails.kwp,
                                                    }));
                                                }
                                                
                                                // Set itemCode for panel types
                                                let updatedItemDetails = { ...itemDetails };
                                                if (itemDetails.name === "Add On" && 
                                                    (itemDetails.type === "580W Panel" || 
                                                     itemDetails.type === "590W Panel" || 
                                                     itemDetails.type === "620W Panel")) {
                                                    updatedItemDetails.itemCode = "PANEL";
                                                }
                                                
                                                if (
                                                    itemDetails.name ===
                                                    "Warranty"
                                                ) {
                                                    if (itemDetails.type === "15 years Warranty (Workmanship)") {
                                                        handleAddProduct(
                                                            product,
                                                            itemDetails,
                                                            itemDetails.quantity
                                                                ? itemDetails.quantity
                                                                : 1
                                                        );
                                                        handleAddProduct(
                                                            {
                                                                title: "15 Years Product Warranty (Goodwe)",
                                                            },
                                                            {
                                                                name: "warranty",
                                                                type: "15 years Product Warranty from Goodwe (Inverter)",
                                                            },
                                                            1
                                                        );
                                                        handleAddProduct(
                                                            {
                                                                title: "15 Years Product Warranty (Jinko)",
                                                            },
                                                            {
                                                                name: "warranty",
                                                                type: "15 years Product Warranty from Jinko (PV Panel)",
                                                            },
                                                            1
                                                        );
                                                        handleAddProduct(
                                                            {
                                                                title: "30 Years Performance Warranty (Jinko)",
                                                            },
                                                            {
                                                                name: "warranty",
                                                                type: "30 years Performance Warranty from Jinko (PV Panel)",
                                                            },
                                                            1
                                                        );
                                                        handleAddProduct(
                                                            {
                                                                title: "1 + 1 Years Leaking Warranty",
                                                            },
                                                            {
                                                                name: "warranty",
                                                                type: "1 + 1 years Leaking Warranty",
                                                            },
                                                            1
                                                        );
                                                    } else {
                                                        handleAddProduct(
                                                            product,
                                                            itemDetails,
                                                            itemDetails.quantity
                                                                ? itemDetails.quantity
                                                                : 1
                                                        );
                                                        handleAddProduct(
                                                            {
                                                                title: "10 Years Product Warranty (Goodwe)",
                                                            },
                                                            {
                                                                name: "warranty",
                                                                type: "10 years Product Warranty from Goodwe (Inverter)",
                                                            },
                                                            1
                                                        );
                                                        handleAddProduct(
                                                            {
                                                                title: "12 Years Product Warranty (Jinko)",
                                                            },
                                                            {
                                                                name: "warranty",
                                                                type: "12 years Product Warranty from Jinko (PV Panel)",
                                                            },
                                                            1
                                                        );
                                                        handleAddProduct(
                                                            {
                                                                title: "30 Years Performance Warranty (Jinko)",
                                                            },
                                                            {
                                                                name: "warranty",
                                                                type: "30 years Performance Warranty from Jinko (PV Panel)",
                                                            },
                                                            1
                                                        );
                                                        handleAddProduct(
                                                            {
                                                                title: "1 + 1 Years Leaking Warranty",
                                                            },
                                                            {
                                                                name: "warranty",
                                                                type: "1 + 1 years Leaking Warranty",
                                                            },
                                                            1
                                                        );
                                                    }
                                                } else {
                                                    handleAddProduct(
                                                        product,
                                                        updatedItemDetails,
                                                        updatedItemDetails.quantity
                                                            ? updatedItemDetails.quantity
                                                            : 1
                                                    );
                                                }
                                                setColorPicker(false);
                                                setItemDetails({
                                                    name: undefined,
                                                    price: undefined,
                                                    type: undefined,
                                                    quantity: undefined,
                                                    voltage: undefined,
                                                    KW: undefined,
                                                    phase: undefined,
                                                    kwp: undefined,
                                                });
                                            }}
                                        >
                                            Add To Cart
                                        </button>
                                    </div>
                                </ColorPickerContainer>
                            </ModalItemContainer>
                        </ModalDetails>
                    </Overlay>
                </OverlayContainer>
            )}
            <div className="posWrapper">
                <div className="checkoutButtons">
                    <div
                        className="salesButton lightred"
                        onClick={() => setFilterList({ type: "watch" })}
                    >
                        Select Products
                    </div>
                </div>
                <div className="posContainer">
                    {" "}
                    {sortedProducts.length > 0 ? (
                        sortedProducts.map((product, i) => {
                            return (
                                <div
                                    key={i}
                                    className="posItem"
                                    onClick={() => {
                                        setColor(product.color);
                                        setProduct(product);
                                        setItemDetails({
                                            name: product.title,
                                            price: product.price ?? undefined,
                                        });
                                        window.scrollTo(0, 0);
                                        setColorPicker(true);
                                    }}
                                >
                                    
                                    <div className="productDetails">
                                        {product.title}
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <></>
                    )}
                </div>
            </div>
        </div>
    );
}
